







import { Vue } from 'vue-property-decorator'; 
 
export default class Banner extends Vue {}
